export default __webpack_public_path__ + "static/media/leaf.6863df5c.png";